import { IModel } from './Model';
import { makeObservable, observable } from 'mobx';

export interface IGenderModel extends IModel {
  genderId: number;
  name: string;
  rowVersion: string;
}

export class GenderModel implements IGenderModel {
  @observable genderId: number;
  @observable name: string;
  @observable rowVersion: string;

  constructor(params: Partial<IGenderModel> = {} as IGenderModel) {
    const { genderId = 0, name = '', rowVersion = '' } = params;

    this.genderId = genderId;
    this.name = name;
    this.rowVersion = rowVersion;
    makeObservable(this);
  }
}
